import { UserRoles } from 'src/utils/constants/auth';

// Route keys to allowed roles. Keys should correspond to first-level paths.
export const ROUTE_PERMISSIONS = {
  '/inventory': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN, UserRoles.AUDITOR],
  '/clients': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN, UserRoles.AUDITOR],
  '/contracts': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN, UserRoles.AUDITOR],
  '/income': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN, UserRoles.AUDITOR],
  '/invoice': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN, UserRoles.AUDITOR],
  '/assign-password': [
    UserRoles.ADMIN,
    UserRoles.SUPER_ADMIN,
    UserRoles.AUDITOR
  ],

  // Full admin-only areas
  '/catalogs': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/parameters': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/insurances': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/billing': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/investors': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/counselors': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/fiscal-balance/interest': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/fiscal-balance/capital': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/accounting-balance/interest': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/accounting-balance/capital': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/balances/fiscal-capital-balance/summary': [
    UserRoles.ADMIN,
    UserRoles.SUPER_ADMIN
  ],
  '/balances/accounting-capital-balance/summary': [
    UserRoles.ADMIN,
    UserRoles.SUPER_ADMIN
  ],
  '/policies': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/distributors': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/distributor-profile': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/quotes': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/quoters': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/tax-accounting': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/identity': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/actions': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/failures': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/upfront-rents': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/santander-clabes': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/santander-reports': [
    UserRoles.ADMIN,
    UserRoles.SUPER_ADMIN,
    UserRoles.AUDITOR
  ],
  '/santander-reports/referenced-payments': [
    UserRoles.ADMIN,
    UserRoles.SUPER_ADMIN,
    UserRoles.AUDITOR
  ],
  '/santander-reports/domiciled-collection': [
    UserRoles.ADMIN,
    UserRoles.SUPER_ADMIN,
    UserRoles.AUDITOR
  ],
  '/santander-reports/automatic-debit-collections': [
    UserRoles.ADMIN,
    UserRoles.SUPER_ADMIN
  ],
  '/transactions': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/card-movements': [UserRoles.ADMIN, UserRoles.SUPER_ADMIN],
  '/super-admin': [UserRoles.SUPER_ADMIN]
};

export const isRouteAllowedForRole = (pathname, role) => {
  const fullPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  let allowed = ROUTE_PERMISSIONS[fullPath];

  // If no exact match, try first-level path
  if (!allowed) {
    const key = `/${pathname.split('/')[1] || ''}`;
    allowed = ROUTE_PERMISSIONS[key];
  }

  if (!allowed) return false;
  return allowed.includes(role);
};
